import { useState, useEffect } from 'react';
import { useDataTable } from '../../../../common/hooks';
import { useRef } from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import { TableBox } from '@lk-gtcom/ecomlab-components';
import { StepItem } from '../../../../components/StepItem/StepItem';
import { BreadcrumbBasic } from '../../../../components/BreadcrumbBasic/BreadcrumbBasic';
import { ModalComponent } from '../../../../components/Modal/ModalComponent/ModalComponent';
import './ModalLaunchHistory.scss'

const ModalLaunchHistory = ({
    setIsModal,
    currentСampaignId,
    setCurrentСampaignId
}) => {

    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    const refContainer = useRef()
    const [isShow, setIsShow] = useState(false)
    const [currentTask, setCurrentTask] = useState(null)

    // Таблица
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const { setLoading } = setTableFuncs;

    // Таблица задач
    const fetchTableData = (params, abortController = new AbortController()) => {
        let sort
        let filtersParam

        if (params) {
            [sort, filtersParam] = params
        }

        setLoading(true)

        let url = `https://apps1.ecomru.ru:4450/api/v1/launches/${currentСampaignId}${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
            : ''}`

        const body = JSON.stringify({
            limit: paginatorRef?.current?.limit,
            page: paginatorRef?.current?.page,
            filters: filtersParam
        })

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw Error(JSON.stringify(res.json()))
                }
            })
            .then(json => {
                setTable(json);
            })
            .catch(err => console.error(err))
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })

    }

    console.log(currentTask)

    // Таблица задач
    const fetchTableDataCurTask = (params, abortController = new AbortController()) => {
        let sort
        let filtersParam

        if (params) {
            [sort, filtersParam] = params
        }

        setLoading(true)

        let url = `https://apps1.ecomru.ru:4450/api/v1/launches/${currentСampaignId}/solutions?task_id=${currentTask}${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
            : ''}`

        const body = JSON.stringify({
            offer_id_list: [
                "all"
            ],
            offer_id_name_search: "",
            limit: paginatorRef?.current?.limit,
            page: paginatorRef?.current?.page,
            filters: filtersParam
        })

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw Error(JSON.stringify(res.json()))
                }
            })
            .then(json => {
                setTable(json);
            })
            .catch(err => console.error(err))
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })

    }

    const resetTable = () => {
        // Сброс номера страниц при перезагрузке таблицы
        paginatorRef.current?.reset();
        paginatorRef.current?.setTotal(0);
    };

    const onAction = (e) => {
        setCurrentTask(e?.['ID изменения']?.[0])
        setIsShow(true)
    }

    useEffect(() => {
        const abortController = new AbortController();
        if (currentTask) {
            fetchTableDataCurTask([], abortController)
        } else {
            fetchTableData([], abortController)
        }
        return () => abortController.abort();
    }, [currentСampaignId, currentTask]);

    const list = [
        {
            label: 'Запуски задач',
            link: 'Запуски задач',
            func: () => {
                resetTable()
                setCurrentTask(null)
                setIsShow(false)
            }
        },
        ...(isShow
            ? [
                {
                    label: `Задача ID-${currentTask}`
                }
            ]
            : [])
    ]

    return (
        <ModalComponent
            title={`История запусков задачи ID-${currentСampaignId || '-'}`}
            onClose={e => {
                setCurrentСampaignId(null)
                setIsModal(false)
            }}
            child={
                <div className='modal-launch-history'>
                    {!isShow && <StepItem
                        title='Результаты запусков по товарам можно получить по нажатию иконки в таблице в колонке "Посмотреть"'
                    />}

                    {isShow && <BreadcrumbBasic
                        list={list}
                    />}

                    <div ref={refContainer}
                        className='modal-launch-history__content'>
                        <TableBox
                            ref={paginatorRef}
                            refContainer={refContainer}
                            paginator={true}
                            onAction={onAction}
                            {...tableProps}
                            fetchCallback={currentTask ? fetchTableDataCurTask : fetchTableData}
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalLaunchHistory }